import * as React from 'react'

import { classList } from 'react-classlist-helper'

import { CloseIcon } from '~/client/src/shared/components/icons/CloseIcon'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import {
  useWorkflowFieldRestriction,
  WorkflowFieldRestrictionItem,
} from './WorkflowFieldRestrictionContext'

interface IProps {
  itemKey: string
  children: React.ReactNode
  isDeleted?: boolean
  className?: string
}

const ICON_SIZE = 'xs'

const WorkflowFieldRestrictionChip: React.FC<IProps> = ({
  itemKey,
  children,
  isDeleted = false,
  className,
}) => {
  const { actions } = useWorkflowFieldRestriction()

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation()
    actions.remove(itemKey)
  }

  return (
    <div
      className={classList({
        'tw:flex tw:items-center tw:flex-none tw:h-5 tw:rounded-[2px] tw:my-0.5 tw:mr-1 tw:max-w-[300px]': true,
        'tw:bg-muted': !isDeleted,
        'tw:bg-destructive/10': isDeleted,
        [className]: !!className,
      })}
    >
      {children}
      <CloseIcon
        size={ICON_SIZE}
        className="tw:ml-[5px] tw:mr-0.5 tw:cursor-pointer tw:flex-none tw:text-muted-foreground hover:tw:text-foreground"
        onClick={handleRemove}
      />
    </div>
  )
}

export function renderRestrictionChip(
  item: WorkflowFieldRestrictionItem,
  icon: React.ReactNode,
): JSX.Element {
  return (
    <WorkflowFieldRestrictionChip
      key={item.key}
      itemKey={item.key}
      isDeleted={item.isDeleted}
    >
      {icon}
      <span
        className={classList({
          'tw:text-body-md tw:font-medium tw:truncate': true,
          'tw:text-foreground': !item.isInactive,
          'tw:text-muted-foreground': !!item.isInactive,
        })}
      >
        {!!item.isDeleted && `[${Localization.translator.deleted}] `}
        {item.label}
      </span>
    </WorkflowFieldRestrictionChip>
  )
}
